import React from 'react';

import { PDPProduct } from '../../model/BonusPointsProduct';

import PDPAddToCartComponent from './PDPAddToCartComponent';
import { PDPAddToCartProvider } from './PDPAddToCartContext';

interface PDPAddToCartProps {
  product: PDPProduct;
  redeemableBalance: number;
  selection: number[];
}

const PDPAddToCart = ({
  product,
  selection,
  redeemableBalance,
}: PDPAddToCartProps): JSX.Element => {
  return (
    <PDPAddToCartProvider
      articleId={product.articleId}
      redeemableBalance={redeemableBalance}
      isArticlePromoted={product.reducedBonuspoints > 0}
      articlePoints={product.bonuspoints}>
      <PDPAddToCartComponent product={product} selection={selection} />
    </PDPAddToCartProvider>
  );
};

export default React.memo(PDPAddToCart);
